const gameTypes = [
  { alt: 'Slots', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/e3705d3c8de302d3aaa19b959dcc7911.png', label: 'Slots' },
  { alt: 'Lotteries', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/ba315f092be57ffeb0852d9b41655a77.png', label: 'Lotteries' },
  { alt: 'Fast Games', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/3dc8520b632897179c42f320f82f774b.png', label: 'Fast Games' },
  { alt: 'Live Casino', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/55e2c6d12f64cba42c80bd857f12be57.png', label: 'Live Casino' },
];

const depositMethods = [
  { alt: 'Visa', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/4e1c565b3cf657b3776e17ad5ad80d66.png' },
  { alt: 'Apple Pay', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/c1025f3fdde343489baa154bc93066eb.png' },
  { alt: 'Mastercard', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/5313f563f78ada0e7fc1068d605c75a0.png' },
  { alt: 'PayID', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/702aa34e0413710388edab0ff4c8ff03.png' },
  { alt: 'Google Pay', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/afbab14e7a9e04d3e83003b2c3289f93.png' },
  { alt: 'Osko', src: 'https://storage.readdy-site.link/project_files/40e57c8e-e521-43c1-9edb-1c2e9563c64a/362207a9-29d8-48d6-bb84-d63e36ef3820_osko.png?v=773de6c77c0ec98f251ebdddef452887' },
];

const withdrawMethods = [
  { alt: 'Visa', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/4e1c565b3cf657b3776e17ad5ad80d66.png' },
  { alt: 'Apple Pay', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/c1025f3fdde343489baa154bc93066eb.png' },
  { alt: 'Mastercard', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/5313f563f78ada0e7fc1068d605c75a0.png' },
  { alt: 'PayID', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/702aa34e0413710388edab0ff4c8ff03.png' },
  { alt: 'Google Pay', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/afbab14e7a9e04d3e83003b2c3289f93.png' },
  { alt: 'Osko', src: 'https://storage.readdy-site.link/project_files/40e57c8e-e521-43c1-9edb-1c2e9563c64a/362207a9-29d8-48d6-bb84-d63e36ef3820_osko.png?v=773de6c77c0ec98f251ebdddef452887' },
];

const bonuses = [
  'Every Deposit Random Bonus',
  'Monthly Deposit Ranking Bonus',
  'Daily Easy Step Bonus',
  'Slot Welcome Bonus',
  'Daily Deposit Progressive Bonus',
  'Social Media Task Bonus',
  'Lucky Wheel Bonus',
  'VIP Loyalty Rewards',
  'VIP Golden Egg Bonus',
  'Red Envelope Bonus',
];

const supportChannels = [
  { alt: 'Email', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/081c1f1693e98fd0413ce558fa8523d5.png', label: 'Email' },
  { alt: 'WhatsApp', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/b5dfa8f33a730cb1fb8e2ad8b12a46dc.png', label: 'WhatsApp' },
  { alt: 'Telegram', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/617dc8e06db0eb0c3599ffd53e778305.png', label: 'Telegram' },
  { alt: 'Live Chat', src: 'https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/fc7ed2ffdfc298bfd9e4455c646e3d13.png', label: 'Live Chat' },
];

function SidebarBlock({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="glass-card rounded-xl p-3 md:p-4">
      <div className="text-blue-600 font-bold text-xs uppercase tracking-widest mb-2 md:mb-3 pb-2 border-b border-blue-200/50 flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse"></span>
        {title}
      </div>
      {children}
    </div>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between items-start py-1.5 border-b border-blue-100/50 last:border-0 gap-2">
      <span className="text-slate-400 text-xs">{label}</span>
      <span className="text-slate-700 text-xs font-medium text-right">{value}</span>
    </div>
  );
}

export default function Sidebar() {
  return (
    <aside className="w-full md:w-[260px] md:max-w-[280px] md:flex-shrink-0 lg:w-[280px] lg:max-w-none xl:w-[300px] flex flex-col gap-3 md:gap-4">
      <SidebarBlock title="About iPAY9">
        <InfoRow label="Owner" value="iPAY9 Group" />
        <InfoRow label="Established" value="2020" />
        <InfoRow label="License" value="PAGCOR / Curacao" />
        <InfoRow label="Language" value="EN" />
        <InfoRow label="Players" value="Over 10 million" />
        <InfoRow label="Min. Deposit" value="AUD 10" />
        <InfoRow label="Min. Withdrawal" value="AUD 50" />
      </SidebarBlock>

      <SidebarBlock title="Casino Game Types">
        <div className="grid grid-cols-2 md:grid-cols-1 gap-2">
          {gameTypes.map((g) => (
            <div key={g.label} className="flex items-center gap-3 group cursor-pointer">
              <div className="w-8 h-8 flex-shrink-0 rounded-lg bg-blue-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                <img alt={g.alt} className="w-5 h-5 object-contain" src={g.src} />
              </div>
              <span className="text-slate-600 text-sm group-hover:text-blue-600 transition-colors">{g.label}</span>
            </div>
          ))}
        </div>
      </SidebarBlock>

      <SidebarBlock title="Payment Methods">
        <div className="mb-3">
          <div className="text-slate-400 text-xs mb-2 font-semibold flex items-center gap-1">
            <i className="ri-arrow-down-circle-line text-blue-500"></i>Deposit
          </div>
          <div className="flex flex-wrap gap-2">
            {depositMethods.map((m) => (
              <div key={m.alt} className="h-8 md:h-9 flex items-center bg-slate-50 rounded px-2 hover:bg-blue-50 transition-colors">
                <img alt={m.alt} className="h-5 md:h-6 w-auto object-contain" src={m.src} />
              </div>
            ))}
          </div>
        </div>
        <div className="mb-3">
          <div className="text-slate-400 text-xs mb-2 font-semibold flex items-center gap-1">
            <i className="ri-arrow-up-circle-line text-blue-500"></i>Withdrawal
          </div>
          <div className="flex flex-wrap gap-2">
            {withdrawMethods.map((m) => (
              <div key={m.alt} className="h-8 md:h-9 flex items-center bg-slate-50 rounded px-2 hover:bg-blue-50 transition-colors">
                <img alt={m.alt} className="h-5 md:h-6 w-auto object-contain" src={m.src} />
              </div>
            ))}
          </div>
        </div>
        <div className="text-slate-400 text-xs mb-3">Currencies: <span className="text-slate-600 font-medium">AUD</span></div>
        <div className="flex gap-4">
          <div>
            <div className="text-slate-400 text-xs">Min. Deposit:</div>
            <div className="text-blue-600 text-sm font-semibold">AUD 10</div>
          </div>
          <div>
            <div className="text-slate-400 text-xs">Min. Withdrawal:</div>
            <div className="text-blue-600 text-sm font-semibold">AUD 50</div>
          </div>
        </div>
      </SidebarBlock>

      <SidebarBlock title="Bonuses &amp; Promotions">
        <div className="flex flex-wrap gap-2">
          {bonuses.map((b) => (
            <span key={b} className="bg-blue-50 border border-blue-200/50 text-slate-600 text-xs px-2.5 py-1 rounded-md hover:border-blue-300 hover:text-blue-600 transition-all duration-200 cursor-default">
              {b}
            </span>
          ))}
        </div>
      </SidebarBlock>

      <SidebarBlock title="Devices">
        <div className="flex gap-6">
          <div className="flex items-center gap-2 group cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors">
              <img alt="Android" className="w-5 h-5 object-contain" src="https://dk88-official.com/wp-content/uploads/2024/06/Android-icon.webp" />
            </div>
            <span className="text-slate-600 text-sm group-hover:text-blue-600 transition-colors">Android</span>
          </div>
          <div className="flex items-center gap-2 group cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors">
              <img alt="iOS" className="w-5 h-5 object-contain" src="https://dk88-official.com/wp-content/uploads/2024/06/Apple-icon.webp" />
            </div>
            <span className="text-slate-600 text-sm group-hover:text-blue-600 transition-colors">iOS</span>
          </div>
        </div>
      </SidebarBlock>

      <SidebarBlock title="Official License">
        <div className="flex items-center gap-4">
          <img alt="PAGCOR License" className="h-8 md:h-10 w-auto object-contain" src="https://storage.readdy-site.link/project_files/40e57c8e-e521-43c1-9edb-1c2e9563c64a/2994a7f8-d354-4e92-8b12-bf8edec11797_1fbd0940613965ecea80d.png?v=4d50cb6abdbf178623fa29265f139e0e" />
          <img alt="Curacao Gaming" className="h-8 md:h-10 w-auto object-contain" src="https://static.readdy.ai/image/b513b5b4a847779ee65de1525456761b/ece023fab9c3aedb4a1e49d589dce436.png" />
        </div>
      </SidebarBlock>

      <SidebarBlock title="Support">
        <div className="grid grid-cols-2 gap-3">
          {supportChannels.map((s) => (
            <div key={s.label} className="flex items-center gap-2 group cursor-pointer">
              <div className="w-7 h-7 flex-shrink-0 bg-blue-50 rounded-md flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                <img alt={s.alt} className="w-4 h-4 object-contain" src={s.src} />
              </div>
              <span className="text-slate-600 text-sm group-hover:text-blue-600 transition-colors">{s.label}</span>
            </div>
          ))}
        </div>
      </SidebarBlock>
    </aside>
  );
}
